"use client"

import clsx from "clsx"
import { useState } from "react"
import { createPortal } from "react-dom"
import { npPagePbClassName } from "src/components/generic/constants"
import { useBackwardForwardCacheRestored } from "src/components/hooks/useBackwardForwardCacheRestored"
import { useEventCallback } from "src/components/hooks/useEventCallback"
import { useKeydown } from "src/components/hooks/useKeydown"
import { usePreventBodyScroll } from "src/components/hooks/usePreventBodyScroll"
import { useStickyHeaderState } from "src/components/sections/header/stickyHeader"
import { SanityAnnouncementData } from "src/data/sanity/types"
import { HeaderIconLink } from "./HeaderIconLink"
import { HeaderTextLinks } from "./HeaderTextLinks"

export type HeaderMenuButtonProps = {
  announcement?: SanityAnnouncementData | null
}

export const HeaderMenuButton = ({ announcement }: HeaderMenuButtonProps) => {
  const [visible, setVisible] = useState(false)
  const stickyHeaderState = useStickyHeaderState()

  const toggle = useEventCallback(() => setVisible((prev) => !prev))
  const hide = useEventCallback(() => setVisible(false))

  usePreventBodyScroll(visible)
  useKeydown("Escape", hide)
  useBackwardForwardCacheRestored(hide)

  const top = stickyHeaderState.visible ? stickyHeaderState.header?.clientHeight || 0 : 0

  return (
    <>
      <HeaderIconLink onClick={toggle} iconName={visible ? "close" : "menu"} title="Menü" />

      {visible &&
        createPortal(
          <div
            style={{ top }}
            className={clsx("z-modal fixed inset-0 flex flex-col gap-px overflow-y-auto bg-white", npPagePbClassName)}
          >
            <button type="button" aria-label="Schließen" onClick={hide} className="absolute inset-0 size-full" />

            <HeaderTextLinks announcement={announcement} mobile />
          </div>,
          document.body,
        )}
    </>
  )
}
